/**
 * [02/11/2026] Plano da mãe no momento de cada evento do analytics interno.
 *
 * O PlanContext publica aqui o estado que já resolveu; o trackAnalytics lê e
 * grava `plan` e `in_trial` na metadata de TODO evento. Enquanto o plano não
 * foi resolvido (ou o provider ainda não montou), o valor é "unknown", nunca
 * "free": free é afirmação, e falha de leitura não é plano.
 *
 * Fica só na tabela interna — `plan`/`in_trial` estão em PARAMS_PROIBIDOS e
 * nunca chegam ao GA4/Firebase/Meta.
 */
export type PlanoDoEvento = "free" | "essencial" | "materna360" | "unknown";

export interface SnapshotPlano {
  plan: PlanoDoEvento;
  /** `null` enquanto o plano não está resolvido (não sabemos). */
  in_trial: boolean | null;
}

const DESCONHECIDO: SnapshotPlano = { plan: "unknown", in_trial: null };
let atual: SnapshotPlano = DESCONHECIDO;

export function publicarPlanoParaEventos(entrada: {
  plan: string | null | undefined;
  unresolved: boolean;
  subscriptionStatus: string | null | undefined;
}): void {
  if (entrada.unresolved) {
    atual = DESCONHECIDO;
    return;
  }
  const plan: PlanoDoEvento =
    entrada.plan === "free" || entrada.plan === "essencial" || entrada.plan === "materna360"
      ? entrada.plan
      : "unknown";
  atual = { plan, in_trial: plan === "unknown" ? null : entrada.subscriptionStatus === "trialing" };
}

export function planoParaEventos(): SnapshotPlano {
  return atual;
}

/** Só para testes. */
export function limparPlanoParaEventos(): void {
  atual = DESCONHECIDO;
}
